import { useContext, useRef } from 'react';
import styled from 'styled-components';
import { ContentLayoutProps } from '..';
import ScrollToTop from '../../components/ScrollToTop';
import { TRACKER_TYPE } from '../../constants/constants';
import { useStep } from '../../hooks/useStep';
import { useTracker } from '../../hooks/useWebAnalyse';
import { store } from '../../store/store';
import { FormText, Title1 } from '../../styles/TypoStyle';
import { Step } from '../../utils/Steps';
import { ActionFormContainer } from '../ActionForm/ActionFormContainer';
import { FooterContainer } from '../FooterContainer';

export const GenericContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  overflow: visible;
  margin: 24px 16px 0px 16px;
  padding-bottom: 32px;
  base-input,
  gender-input,
  date-input,
  api-input,
  combo-input,
  base-select,
  chevron-select,
  numeric-input,
  email-input,
  phone-input,
  button-link {
    color: var(--colors-on-background);
    font-family: var(--typo-form-font-family);
    font-size: var(--typo-form-font-size);
    letter-spacing: var(--typo-form-letter-spacing);
    line-height: var(--typo-form-line-height);
    font-weight: var(--typo-form-font-weight);
  }
  button-link {
    color: var(--colors-primary-default);
  }
  base-checkbox {
    display: flex;
  }
  selected-button {
    font-family: var(--typo-form-font-family);
    font-size: var(--typo-form-font-size);
    letter-spacing: var(--typo-form-letter-spacing);
    line-height: var(--typo-form-line-height);
    font-weight: var(--typo-form-font-weight);
    align-self: stretch;
    flex: 23%;
    height: 34px;
  }
  date-input {
    --width-component: 166px;
    width: 100%;
    margin-top: 16px;
  }
  gender-input {
    align-self: stretch;
    margin-top: 16px;
    text-align: center;
  }
  base-input {
    align-self: stretch;
    margin-top: 16px;
  }
  api-input {
    align-self: stretch;
    margin-top: 16px;
  }
  combo-input {
    align-self: stretch;
    margin-top: 16px;
    z-index: 999;
  }
  phone-input {
    align-self: stretch;
    margin-top: 16px;
    --width-component: 224px;
  }
  email-input {
    align-self: stretch;
    margin-top: 16px;
  }
  chevron-select {
    align-self: stretch;
    margin-top: 16px;
    --padding-input: 11px 16px;
  }
  numeric-input {
    align-self: stretch;
    margin-top: 16px;
  }
  numeric-stepper {
    font-family: var(--typo-title1-font-family);
    width: 128px;
  }
  numeric-input {
    align-self: stretch;
    margin-top: 16px;
  }
`;

export const FormTitle = styled(Title1)`
  //not desktop
  @media (max-width: 1024px) {
    font-size: var(--typo-title2-font-size);
    line-height: var(--typo-title2-line-height);
  }
`;

export const FormDescription = styled(FormText)`
  color: var(--colors-on-secondary);
  margin-top: 16px;
  margin-bottom: 8px;
`;

export const FormLayout: React.FunctionComponent<ContentLayoutProps> = ({ content, currentStep }) => {
  const { stepData } = useStep(currentStep);
  const titleRef = useRef(null);
  const { modalStatus, geoLoc } = useContext(store);
  //web analyse hook
  const trakerTypes: TRACKER_TYPE[] =
    currentStep === Step.LOGEMENT
      ? [TRACKER_TYPE.P1, TRACKER_TYPE.E3, TRACKER_TYPE.E4]
      : [TRACKER_TYPE.P2, TRACKER_TYPE.E3, TRACKER_TYPE.E4];
  useTracker(trakerTypes, stepData.webAnalyseDetails, undefined, undefined, modalStatus, geoLoc);

  return (
    <GenericContainer>
      <FormTitle ref={titleRef} id={`${stepData.name}-title`}>
        {stepData.title}
      </FormTitle>
      <FormDescription id={`${stepData.name}-description`}>{stepData.description}</FormDescription>
      {content}
      <ScrollToTop elementRef={titleRef}>
        <ActionFormContainer currentStep={currentStep} />
        <FooterContainer currentStep={stepData.path} />
      </ScrollToTop>
    </GenericContainer>
  );
};
